import { render, staticRenderFns } from "./healthInfo.vue?vue&type=template&id=f0c66f76&scoped=true&"
import script from "./healthInfo.vue?vue&type=script&lang=js&"
export * from "./healthInfo.vue?vue&type=script&lang=js&"
import style0 from "./healthInfo.vue?vue&type=style&index=0&id=f0c66f76&prod&lang=less&scoped=true&"
import style1 from "./healthInfo.vue?vue&type=style&index=1&id=f0c66f76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c66f76",
  null
  
)

export default component.exports